(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.handleCardATC = function(btn, event) {
    event.preventDefault();
    event.stopPropagation();

    const form = btn.closest('form');
    if (!form) return;

    // Show checkmark animation
    btn.classList.add('is-added');
    btn.querySelector('.atc-button-text').textContent = 'Added';

    // Submit via fetch
    const formData = new FormData(form);
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    cartItemsComponents.forEach(function(item) {
      if (item.dataset && item.dataset.sectionId) {
        formData.append('sections', item.dataset.sectionId);
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      // Dispatch cart add event so cart icon updates
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));

      // Open the cart drawer after a short delay for the animation — unless the theme setting
      // "auto-open cart drawer" is off, then stay on the page and confirm with a toast.
      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && !drawerEl.hasAttribute('auto-open')) {
        const titleEl = btn.closest('product-card') && btn.closest('product-card').querySelector('h3, h4, .product-card__title');
        if (window.twAddedToast) window.twAddedToast(titleEl ? titleEl.textContent.trim() : '');
      } else setTimeout(function() {
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          // Refresh cart drawer contents first
          fetch('/?sections=' + document.querySelector('cart-items-component')?.dataset?.sectionId)
            .then(function(r) { return r.json(); })
            .then(function(sections) {
              const sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId;
              if (sectionId && sections[sectionId]) {
                const temp = document.createElement('div');
                temp.innerHTML = sections[sectionId];
                const newInner = temp.querySelector('[data-hydration-key="cart-drawer-inner"]');
                const currentInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
                if (newInner && currentInner) {
                  currentInner.innerHTML = newInner.innerHTML;
                }
              }
              cartDrawer.open();
            })
            .catch(function() {
              cartDrawer.open();
            });
        }
      }, 600);

      // Reset button after delay
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.querySelector('.atc-button-text').textContent = 'Add to Basket';
      }, 2000);
    })
    .catch(function(err) {
      console.error('Add to Basket failed:', err);
      btn.classList.remove('is-added');
      btn.querySelector('.atc-button-text').textContent = 'Add to Basket';
    });
  };
  } catch(e) { console.error(e); }
})();

})();
